module.exports = __webpack_public_path__ + "images/help/video-preview-payment-892724796f4bdda9d26e716e032f16c0.jpg";